import { Flex, Heading, Stack, Text } from "@chakra-ui/react"
import type { ReactNode } from "react"

import { type BreadcrumbNode, PageBreadcrumbs } from "./PageBreadcrumbs"

export interface PageHeaderProps {
  title?: string
  description?: ReactNode
  breadcrumbs?: BreadcrumbNode[]
  actions?: ReactNode
  headingId?: string
}

export function PageHeader({
  title,
  description,
  breadcrumbs,
  actions,
  headingId,
}: PageHeaderProps) {
  const shouldRenderHeader = Boolean(title || description || actions)
  const shouldRenderBreadcrumbs = Boolean(breadcrumbs && breadcrumbs.length > 0)

  if (!shouldRenderHeader && !shouldRenderBreadcrumbs) {
    return null
  }

  return (
    <Stack gap={shouldRenderBreadcrumbs ? 2 : 4} mb={1}>
      {shouldRenderBreadcrumbs && <PageBreadcrumbs items={breadcrumbs} />}

      {shouldRenderHeader && (
        <Flex
          align={{ base: "flex-start", md: "center" }}
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          gap={4}
          wrap="wrap"
        >
          <Stack gap={0} flex="1">
            {title ? (
              <Heading id={headingId} size="lg">
                {title}
              </Heading>
            ) : null}
            {description ? (
              typeof description === "string" ? (
                <Text color="fg.muted">{description}</Text>
              ) : (
                description
              )
            ) : null}
          </Stack>

          {actions ? (
            <Stack
              direction={{ base: "column", sm: "row" }}
              gap={3}
              align={{ base: "stretch", sm: "center" }}
              justify="flex-end"
              alignSelf={{ base: "stretch", md: "flex-start" }}
            >
              {actions}
            </Stack>
          ) : null}
        </Flex>
      )}
    </Stack>
  )
}
